export function startCountdown() {
  const targetTime = new Date("2025-05-24" + "T00:00").getTime();

  function updateTimer() {
    const now = Date.now();
    const diff = targetTime - now;

    if (diff <= 0) {
      location.reload();
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    const timerEl = document.getElementById("timer");
    if (timerEl) {
      timerEl.textContent = `${days}d ${hours}h ${minutes}m ${seconds}s`;
    }
  }

  updateTimer();
  setInterval(updateTimer, 1000);
}
